import React from 'react';
import { AppRouter } from './AppRouter';
import { FacebookPixel } from './components/FacebookPixel';
export function App() {
  return <>
      <FacebookPixel pixelId="1227156125769606" data-id="element-0" />
      <AppRouter data-id="element-1" />
    </>;
}